import React from 'react'

const MessageSendingAnimation = () => {
  return (
    <div>
        <span className="submitting-loader"></span>
    </div>
  )
}

export default MessageSendingAnimation